import { render, staticRenderFns } from "./chatGroupSettingsDialog.vue?vue&type=template&id=32bc85d5"
import script from "./chatGroupSettingsDialog.vue?vue&type=script&lang=js"
export * from "./chatGroupSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports